import { styled } from '@mui/material/styles'

export const Container = styled('div')`
  padding: 32px;
  width: 100%;
  overflow: hidden;
`
